import React from "react";
import PropTypes from "prop-types";
import TranslatorContext from "../contexts/TranslatorContext";
import useTranslationRepository from "../hooks/use-translation-repository";

function Translator(props) {

    const repository = useTranslationRepository();

    function prefixName(name) {

        if (props.namespace) {
            return [
                props.namespace,
                name
            ].join('.');
        }

        return name;
    }

    function getRaw(name = null, applyNamespace = true) {
        if (applyNamespace === true) {
            name = prefixName(name);
        }

        return repository.getRaw(name);
    }

    function trans(name = null, parameters = {}, applyNamespace = true) {
        if (applyNamespace === true) {
            name = prefixName(name);
        }

        return repository.trans(name, parameters);
    }

    function transChoice(name = null, count = null, parameters = {}, applyNamespace = true) {
        if (applyNamespace === true) {
            name = prefixName(name);
        }

        return repository.transChoice(name, count, parameters);
    }

    function translate(name, {data, count}, defaultValue = null) {
        let translation;

        if (typeof count === 'number') {
            translation = translator.transChoice(name, count, data);

            if (translation === prefixName(name)) {
                translation = translator.transChoice(name, count, data, false);
            }

            if (translation === name && !!defaultValue) {
                translation = defaultValue;
            }
        } else {
            translation = translator.transChoice(name, count, data);

            if (translation === prefixName(name)) {
                translation = translator.transChoice(name, count, data, false);
            }

            if (translation === name && !!defaultValue) {
                translation = defaultValue;
            }
        }

        return translation;
    }

    const translator = {
        prefixName,
        trans,
        transChoice,
        translate,
        getRaw,
    };

    return (
        <TranslatorContext.Provider value={translator}>
            <React.Fragment>
                {props.children}
            </React.Fragment>
        </TranslatorContext.Provider>
    );
}

Translator.defaultProps = {
    namespace: null,
};

Translator.propTypes = {
    namespace: PropTypes.string,
};

export default Translator;
